module.exports = __webpack_public_path__ + "static/media/c200-start-sim-btn.8dfe58ca.png";